import { h, type FunctionalComponent } from '@stencil/core';
import { getAppName } from '../utils/utils';
import type {IDashboardDesktopView} from '../dashboard-views/dashboard-desktop-view';
import type { CtaWidgetv2 } from '../../../../../widgets/cta-widget-v2/cta-widget-v2';

type CtaPublicWidgetsRowProps = Pick<IDashboardDesktopView, 'country' | 'language' | 'hasCtaProductSelector' | 'hasSupportButton' | 'tabName' | 'analyticsTabName' | 'brand' | 'rtl' | 'productNaCountrySelectorLocales' | 'labelProvider' >;
type CtaWidgetDataProps = Partial<CtaWidgetv2> & { iconName: string; library?: string; isShown: boolean; };

export const CtaPublicWidgetsRow: FunctionalComponent<CtaPublicWidgetsRowProps> = (
  props
) => {
    const {
      country,
      language,
      tabName,
      analyticsTabName,
      brand,
      hasCtaProductSelector,
      hasSupportButton,
      productNaCountrySelectorLocales,
      labelProvider
    } = props;

    const targetBrand = getAppName(brand);
    const widgetData: CtaWidgetDataProps[] = [
      {
        header: labelProvider('dashboardCta.productsv2.header', 'Product Selector'),
        content: labelProvider('dashboardCta.productsv2.content', 'Effortlessly discover the products and accessories tailored for your applications.'),
        url: `/${country}/${language}/work/support/product-selector/`,
        iconName: 'squares-checked',
        buttonText: labelProvider('dashboardCta.productsv2.button', 'Use Product Selector'),
        eventCategory: 'Product selector',
        isShown:true
      },
      {
        header: labelProvider('dashboardCta.helpCenter.header',
          'Help Center'),
        content: labelProvider( 'dashboardCta.helpCenter.content',
          'Find support, popular tools and resources for all your needs in one place.'),
        url: `/${country}/${language}/work/support/customer-care/contact-schneider-electric.jsp`,
        iconName: 'question-mark',
        buttonText: labelProvider('dashboardCta.button.helpCenter', labelProvider('dashboardCta.button.exploreNow', 'Explore now')),
        eventCategory: 'Help Center',
        isShown: true
      },
      {
        header: labelProvider('dashboardCta.ourSolutions.header',
          'Discover our solutions'),
        content: labelProvider( 'dashboardCta.ourSolutions.content',
          'Maximize energy usage and access energy management solutions anytime.'),
        url: `/${country}/${language}/work/solutions/`,
        iconName: 'light-bulb-on',
        buttonText: labelProvider('dashboardCta.button.exploreNow',
          'Explore now'),
        eventCategory: 'Discover our solutions',
        isShown: true
      },
      {
        header: labelProvider('dashboardCta.contactSales.header', 'Contact Sales'),
        content: labelProvider('dashboardCta.contactSales.content', 'Start your sales inquiry online and an expert will connect with you.'),
        url: `/${country}/${language}/work/support/customer-care/contact-sales.jsp`,
        iconName: 'headset',
        buttonText: labelProvider('dashboardCta.contactSales.button', 'Get a Quote'),
        eventCategory: 'Contact Sales',
        isShown: true
      }
    ];
    // Update isShown for Product Selector widget based on hasCtaProductSelector
    if (!hasCtaProductSelector) {
      widgetData[0].isShown = false;
    }

    return (
      <div class={{'dashboard__tiles dashboard__tiles--se widget-offset-bottom-myse': brand === 'se' }}>
        {brand === 'se' ? (
          widgetData.map(({ iconName, isShown, ...props }) =>
            isShown ? (
              <uiaas-search-cta-widget-v2
                {...props}
                anchor-target="_blank"
                tab-name={tabName}
                extended-button={false}
              >
                <qds-icon
                  slot="icon"
                  size="large"
                  name={iconName}
                  className="dashboard-widget-icon"
                />
              </uiaas-search-cta-widget-v2>
            ) : null
          )
        ) : (
          (hasCtaProductSelector || hasSupportButton) && (
            <div class="cta-public-widgets-row">
              {hasCtaProductSelector && !productNaCountrySelectorLocales && (
                <div class="cta-product-selector-container widget-offset-bottom">
                  <uiaas-search-widget-cta-product-selector
                    app-name={targetBrand}
                    country={country}
                    language={language}
                    is-dashboard-view={true}
                    dashboard-tab-name={tabName}
                    analytics-tab-name={analyticsTabName}
                  />
                </div>
              )}
              <div class="cta-product-selector-container widget-offset-bottom">
                {hasSupportButton && (
                  <uiaas-search-support-button
                    app-name={targetBrand}
                    country={country}
                    language={language}
                    is-dashboard-view="true"
                    dashboard-tab-name={tabName}
                    analytics-tab-name={analyticsTabName}
                  />
                )}
              </div>
            </div>
          )
        )}
      </div>
    );
};
